// extracted by mini-css-extract-plugin
module.exports = {"root":"DepositFormIframe_root__Kny6P","frameWrapper":"DepositFormIframe_frameWrapper__o4FHq"};